module.exports = __webpack_public_path__ + "static/media/1.eabfebef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80285/1.jpg
// module id = 775
// module chunks = 0